import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import { CustomTable, GeneralContainer } from '../../../../components';
import { PetitionsResponse } from '../../types/petitions-response';
import { ShareResponse } from '../../../../share';
import SearchRow from '../components/Filters';
import CustomAlert from '../../../../components/CustomAlert/CustomAlert';

interface PetitionsViewProps {
  data?: PetitionsResponse;
  onViewCreate: () => void;
  onPagination: (page: number, pageSize: number) => void;
  onViewDetail: (id: string) => void;
  formik: any;
  states?: ShareResponse[];
  isLoading: boolean;
  onResetFilters: () => void;
}

const PetitionsView: React.FC<PetitionsViewProps> = ({
  data,
  onViewCreate,
  onPagination,
  formik,
  states,
  isLoading,
  onResetFilters,
}) => {
  const columns = [
    {
      title: 'Número de ticket',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: (a: any, b: any) => a.ticket.localeCompare(b.ticket),
      align: 'center',
    },
    {
      title: 'Tipo de ticket',
      dataIndex: 'ticket_type',
      key: 'ticket_type',
      sorter: (a: any, b: any) => a.ticket_type.localeCompare(b.ticket_type),
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Fecha de solicitud',
      dataIndex: 'query_date',
      key: 'query_date',
      sorter: (a: any, b: any) => a.query_date.localeCompare(b.query_date),
      align: 'center',
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      key: 'regional',
      sorter: (a: any, b: any) => a.regional.localeCompare(b.regional),
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Seccional',
      dataIndex: 'sectional',
      key: 'sectional',
      sorter: (a: any, b: any) => a.sectional.localeCompare(b.sectional),
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Estado de solicitud',
      dataIndex: 'status_id',
      key: 'status_id',
      align: 'center',
      render: (status: string) => {
        return <CustomAlert status={status} />
      },
    },
    {
      title: 'Nuevo responsable',
      dataIndex: 'new_responsible',
      key: 'new_responsible',
      sorter: (a: any, b: any) =>
        (a.new_responsible || '').localeCompare(b.new_responsible || ''),
      align: 'center',
      render: (_: any, record: any) =>
        record.new_responsible_doc && record.new_responsible
          ? `${record.new_responsible_doc} - ${record.new_responsible}`
          : 'N/A',
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
      sorter: (a: any, b: any) => a.observations.localeCompare(b.observations),
      align: 'center',
      responsive: ['lg'],
      width: 300,
      render: (text: string) => {
        return (
          <Tooltip title={text || 'Sin registro'}>
            <div
              style={{
                maxWidth: 250,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                margin: '0 auto',
              }}
            >
              {text || 'Sin registro'}
            </div>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <GeneralContainer
      title="Mis solicitudes"
      onActionClick={onViewCreate}
      isLoading={isLoading}
    >
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24}>
          <SearchRow
            formik={formik}
            states={states}
            onCancel={onResetFilters}
            isLoading={isLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <CustomTable
            loading={isLoading}
            columns={columns as any}
            dataSource={data?.data?.map((item) => ({
              ...item,
              key: Number(item.id) || -1,
              id: Number(item.id) || -1,
            }))}
            paginationConfig={{
              current: data?.current_page,
              pageSize: data?.per_page,
              total: data?.total,
              onChange: onPagination,
            }}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
    </GeneralContainer>
  );
};

export default PetitionsView;
